import { NgIf, NgFor } from '@angular/common'
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output
} from '@angular/core'
import { MediaComponent, MediaContainer } from '@spartacus/storefront'
import { EbPicture } from '../../features/media/eb-media.interface'
import { EbMediaService } from '../../features/media/eb-media.service'

@Component({
  selector: 'eb-responsive-media',
  templateUrl: './eb-responsive-media.component.html',
  styleUrls: ['./eb-responsive-media.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [NgIf, NgFor]
})
export class EbResponsiveMediaComponent extends MediaComponent implements OnChanges {
  @Input() alignTextLeft: string
  @Output() loaded: EventEmitter<boolean> = new EventEmitter<boolean>()

  picture: EbPicture

  constructor(protected mediaService: EbMediaService) {
    super(mediaService)
  }

  ngOnChanges(): void {
    super.create()
    this.create()
  }

  protected create(): void {
    this.picture = this.mediaService.getPictureByContainer(
      this.container as MediaContainer,
      this.alignTextLeft
    )
  }
}
